export default function () {
  document.addEventListener('click', (event) => {
    const videoContainer = event.target.closest('.HeroVideo__videoContainer');
    if (videoContainer) {
      const lightbox = document.getElementById('lightbox');
      const video = document.getElementById('video');
      const videoEl = document.getElementById('videoEl');

      lightbox.style.display = 'block';
      setTimeout(() => {
        lightbox.style.opacity = '1';
      }, 10); // Use setTimeout to ensure the fade effect works

      videoContainer.style.display = 'none';

      let videoURL = video.getAttribute('src');
      videoURL += '?autoplay=1';
      video.setAttribute('src', videoURL);
      videoEl.play();

      document.querySelector('main').style.zIndex = 'auto';

      document.getElementById('closeVideo').addEventListener('click', () => {
        lightbox.style.opacity = '0';
        setTimeout(() => {
          lightbox.style.display = 'none';
        }, 500); // Match fadeOut duration
        videoEl.pause();
      });

      videoEl.addEventListener('ended', () => {
        lightbox.style.opacity = '0';
        setTimeout(() => {
          lightbox.style.display = 'none';
        }, 500);
        videoEl.pause();
      });

      lightbox.addEventListener('click', (e) => {
        if (e.target.id !== 'videoEl') {
          lightbox.style.opacity = '0';
          setTimeout(() => {
            lightbox.style.display = 'none';
          }, 500);
          videoEl.pause();
        }
      });

      window.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') {
          lightbox.style.opacity = '0';
          setTimeout(() => {
            lightbox.style.display = 'none';
          }, 500);
          videoEl.pause();
        }
      });
    }
  });
}
